import React from "react";
import plansData from "./PlansData";
import "./Plans.css";

const Plans = () => {
  return (
    <div className="plans-container" id="plan">
      <div className="blur plan-blur-1"></div>
      <div className="blur plan-blur-2"></div>
      {/* Plans header */}
      <div className="programs-header">
        <span className="stroke-text">READY TO START </span>
        <span> YOUR JOURNEY </span>
        <span className="stroke-text"> NOW WITHUS </span>
      </div>
      {/* Plans Cards */}

      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span> {plan.name} </span>
            <span> $ {plan.price} </span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src="images/whiteTick.png" alt="" />
                  <span key={i}> {feature} </span>
                </div>
              ))}
            </div>

            <div>
              <span>See more benefits -> </span>
            </div>
            <button className="btn"> Join Now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
